export const MenuItems = [
  {
    name: "Home",
    identifier: ["", "/", "/home"],
    href: "/",
  },
  {
    name: "Service",
    identifier: ["services"],
    href: "/services",
  },
  {
    name: "About",
    identifier: ["about"],
    href: "/about",
  },
  {
    name: "Projects",
    identifier: ["projects"],
    href: "/projects",
  },
  {
    name: "FAQs",
    identifier: ["faqs"],
    href: "/faqs",
  },
];
